/* eslint-disable */
import videojs from 'video.js'
import ScalablePlayer from '../scalableplayer'

var isNull = function (item) {
    if (item === null || item === undefined) {
        return true
    }
    if (typeof item === typeof '' && (item === '' || item === 'null' || item === 'undefined')) {
        return true
    }
    return false
}

export default class InstantPlayer {
    constructor (parentDiv, cloudType, delegate) {
        if (isNull(parentDiv)) {
            return null
        }
        this.parentDiv = parentDiv

        this.bgImage = document.createElement('div')
        this.parentDiv.appendChild(this.bgImage)

        this.screen = document.createElement('div')
        this.parentDiv.appendChild(this.screen)

        this.progressRate = 0
        this.progressArea = document.createElement('div')
        this.parentDiv.appendChild(this.progressArea)

        this.progressBar = document.createElement('span')
        this.progressArea.appendChild(this.progressBar)

        this.addAttribute(this.bgImage, 'bg-image')
        this.addAttribute(this.screen, 'player_container')
        this.addAttribute(this.progressArea, 'cell-progress')
        this.addAttribute(this.progressBar, 'gradation-purple')

        this.cloudType = cloudType
        this.player = null

        this.isPlaying = false
        this.currentPlayingUrl = null
        this.maxResolution = 360
        this.isMute = true

        this.timeoutCallback = null
        this.timeoutID = null
        this.timeLimit = 60000 // ms

        this.errorCallback = null
    }

    destructor () {
        if (this.player !== null) {
            if (this.timeoutID !== null) {
                this.player.clearTimeout(this.timeoutID)
                this.timeoutID = null
            }
            this.isPlaying = false

            this.player.off('error', this.onError.bind(this))

            this.player.unloadTech_()
            this.player = null
        }
    }

    init (mode) {
        let config = {
            controls: false,
            html5: {
                hls: {
                    withCredentials: true
                }
            },
            loadingSpinner: false,
            bigPlayButton: false,
            liveTracker: false,
            controlBar: false,
            errorDisplay: false,
            textTrackSettings: false,
            resizeManager: false
        }
        let video = this.createVideoTag()
        this.player = videojs(video.id, config)
    }

    createVideoTag () {
        let video = document.createElement('video')
        video.preload = 'auto'
        video.style.width = '100%'
        video.style.height = '100%'
        video.id = 'videojs' + this.getPlayerId('wavve')

        this.screen.appendChild(video)

        return video
    }

    load (vodObject, isAutoPlay) {
        let source = this.getSource(vodObject)
        if (source.src === this.currentPlayingUrl && this.isPlaying === true) {
            return
        }
        console.log('InstantPlayer-play: Load (isMute=' + this.isMute + ')')
        this.currentPlayingUrl = source.src
        if (isAutoPlay === true) {
            this.isMute = true
            this.player.muted(this.isMute)
            this.player.autoplay(true)
            this.isPlaying = true
        } else {
            this.player.autoplay(false)
        }
        this.player.ready(this.loaded.bind(this), false)
        this.player.src(source)

        this.unloadedCallback = null
        if (vodObject.type === ScalablePlayer.contentType.LIVE) {
            if (this.timeoutID !== null) {
                this.player.clearTimeout(this.timeoutID)
                this.timeoutID = null
            }

            this.timeoutID = this.player.setTimeout(this.timeout.bind(this), this.timeLimit)
        } else {
            this.progressBar.style.display = 'none'
            if (vodObject.isPreview === true) {
                if (this.timeoutID !== null) {
                    this.player.clearTimeout(this.timeoutID)
                    this.timeoutID = null
                }
                let duration = vodObject.previewTime ? vodObject.previewTime * 1000 : this.timeLimit
                this.timeoutID = this.player.setTimeout(this.timeout.bind(this), duration)
            }
        }
    }

    loaded () {
        if (this.loadedCallback) {
          this.loadedCallback()
        }

        console.log('InstantPlayer-loaded: player was loaded')
        this.player.on('error', this.onError.bind(this))
        this.player.on('ended', this.onComplete.bind(this))
        this.player.on('pause', this.onPause.bind(this))
    }

    unload () {
        if (this.timeoutID !== null) {
            this.player.clearTimeout(this.timeoutID)
            this.timeoutID = null
        }
        this.isPlaying = false
        this.player.reset()
    }

    play () {
        if (this.isPlaying !== true) {
            if (this.timeoutID !== null) {
                this.player.clearTimeout(this.timeoutID)
                this.timeoutID = null
            }
            this.player.play()
            this.isPlaying = true
            this.timeoutID = this.player.setTimeout(this.timeout.bind(this), this.timeLimit)
            console.log("InstantPlayer-play: Let's play")
        }
    }

    pause () {
        if (this.isPlaying === true) {
            this.player.pause()
            this.isPlaying = false
            if (this.timeoutID !== null) {
                this.player.clearTimeout(this.timeoutID)
                this.timeoutID = null
            }
            console.log('InstantPlayer-play: pause')
        }
    }

    timeout () {
        this.pause()
        this.timeoutID = null

        if (this.timeoutCallback) {
            this.timeoutCallback()
        }
        console.log('InstantPlayer-play: timeout')
    }

    setMute (isMute) {
        this.isMute = isMute
        let ret = this.player.muted(isMute)
        console.log('InstantPlayer-setMute: isMute=' + isMute + ', ret=' + ret)
    }

    setInitImage (path) {
        this.bgImage.style.backgroundImage = String('url(' + path + ')')
        this.player.poster(path)
    }

    getProgressRate () {
        return this.progressRate
    }

    setLoadedCallback (func) {
        this.loadedCallback = func
    }

    setTimeoutCallback (func) {
        this.timeoutCallback = func
    }

    setErrorCallback (func) {
        this.errorCallback = func
    }

    onError () {
        let e = this.player.error()
        console.error('InstantPlayer-onError: Videojs error (' + e + ')')
        if (this.errorCallback) {
            this.errorCallback(ScalablePlayer.ErrorType.PLAYER_INTERNAL, e)
        }
    }

    onComplete () {
        if (this.timeoutID) {
            clearTimeout(this.timeoutID);
            this.timeoutID = null;
        }
        if (this.timeoutCallback) {
            this.timeoutCallback()
        }
        console.log('InstantPlayer-play: onComplete')
    }

  onPause () {
    const hls = this.player.tech({ IWillNotUseThisInPlugins: true }).hls;
    if (hls) {
      // PlaylistLoader pause
      if (hls.playlists && hls.playlists.pause) {
        hls.playlists.pause();
      }

      // SegmentLoader 멈추기 (main, audio 각각 pause)
      if (hls.mainSegmentLoader && hls.mainSegmentLoader.pause) {
        hls.mainSegmentLoader.pause();
      }
      if (hls.audioSegmentLoader && hls.audioSegmentLoader.pause) {
        hls.audioSegmentLoader.pause();
      }
    }
  }

    setMaxResolution (resolution) {
        if (isNull(this.player) || isNull(this.player.tech_) || isNull(this.player.tech_.hls) || isNull(this.player.tech_.hls.qualityLevels_)) {
            return false
        }

        let i = 0
        let length = this.player.tech_.hls.qualityLevels_.levels_.length
        let enabledTrackCnt = 0

        for (i = 0; i < length; i++) {
            let curTrack = this.player.tech_.hls.qualityLevels_.levels_[i]
            if (curTrack.height > resolution) {
                curTrack.enabled = false
            } else {
                curTrack.enabled = true
                enabledTrackCnt++
            }
        }

        if (enabledTrackCnt === 0) {
            for (i = 0; i < length; i++) {
                let curTrack = this.player.tech_.hls.qualityLevels_.levels_[i]
                curTrack.enabled = true
            }
            return false
        }

        return true
    }

    updateUI (metaObj) {
        let progressRate = 0

        if (!isNull(metaObj) && !isNull(metaObj.playStartTime) && !isNull(metaObj.playEndTime) && !isNull(metaObj.playCurrentTime)) {
            if (metaObj.playEndTime <= metaObj.playCurrentTime) {
                progressRate = 100
            } else if (metaObj.playStartTime >= metaObj.playCurrentTime) {
                progressRate = 0
            } else {
                progressRate = (metaObj.playEndTime - metaObj.playCurrentTime) / (metaObj.playEndTime - metaObj.playStartTime) * 100
                if (progressRate > 100) {
                    progressRate = 100
                } else if (progressRate < 0) {
                    progressRate = 0
                } else {
                    progressRate = Math.ceil(progressRate)
                }
            }
        }

        this.progressRate = progressRate
        this.progressBar.style.width = String(progressRate + '%')
    }

    changeMode (mode) {

    }

    getPlayerId (media) {
        let getYMDHIS = function () {
            let now = new Date()
            let yy = Number(now.getFullYear())
            let mm = Number(now.getMonth()) + 1
            let dd = Number(now.getDate())
            let hh = Number(now.getHours())
            let ii = Number(now.getMinutes())
            let ss = Number(now.getSeconds())

            return '' + yy + mm + dd + hh + ii + ss
        }
        let getRandomInt = function (value) {
            let r = Math.random()
            if (r === 1) {
                return value - 1
            }

            return Math.floor(r * value)
        }
        let generateRandomString = function (num) {
            let rstr = ''
            for (let i = 0; i < num; i++) {
                let s = String(1 + getRandomInt(5))
                rstr = rstr + s
            }
            return rstr
        }

        return generateRandomString(5) + media + getYMDHIS()
    }

    getSource (vodObject) {
        let source = {}

        if (vodObject.isSignedCookie === true) {
            source.withCredentials = true
        }

        source.src = vodObject.vodUrl.replace('https:', location.protocol)
        source.type = 'video/mp4'
        // if (vodObject.vodUrl.indexOf(".m3u8") !== -1) {
            source.type = 'application/x-mpegURL'
        // }
        // if (vodObject.vodUrl.indexOf(".mpd") !== -1) source.type = "application/dash+xml";

        /* if (vodObject.isDRM === true) {
            console.log("vodObject.isDRM "+ vodObject.isDRM )

            vodObject.vodUrl = vodObject.vodUrl.replace(/http:/g, "https:");
            vodObject.drmHost = vodObject.drmHost.replace(/http:/g, "https:")

            let header = new Object();
            if(vodObject.drmHeader != null) {
                header = {"pallycon-customdata" : vodObject.drmHeader};
            }

            switch(vodObject.drmType) {
                case DRM_TYPE.WIDEVINE:
                    // video.js v7.6 적용
                    if (jarvis.lib.useVideojsV7) {
                        source.keySystems = {
                            'com.widevine.alpha': {
                                url: vodObject.drmHost,
                                licenseHeaders: header
                            }
                        };
                    }
                    else {
                        // video.js v6 적용
                        source.keySystemOptions = [];
                        source.keySystemOptions.push({
                            name:'com.widevine.alpha',
                            options: {
                                serverURL: vodObject.drmHost,
                                httpRequestHeaders:header
                            }
                        });
                    }
                    break;
                case DRM_TYPE.PLAY_READY:
                    source.keySystemOptions = [];
                    source.keySystemOptions.push({
                        name: 'com.microsoft.playready',
                        options: {
                            serverURL: vodObject.drmHost,
                            httpRequestHeaders: header
                        }
                    });
                    break;
                case DRM_TYPE.FAIR_PLAY:
                    let fairPlayCertificateUri = "https://license.wavve.com/ri/fpsKeyManager.do?siteId=U1ZN";//redirect to 'https://tokyo.pallycon.com/ri/fpsKeyManager.do?siteId=U1ZN',
                    if (jarvis.lib.getCloudType() === CLOUD_TYPE.AZURE) {
                        fairPlayCertificateUri: "https://license.wavve.com/ri/fpsKeyManager.do?siteId=U1ZN";
                    }
                    source.keySystems = {
                        "com.apple.fps.1_0": {
                            licenseUri: vodObject.drmHost,
                            httpRequestHeaders : header,
                            // video.js v7 적용을 위한 코드 (httpRequestHeaders 삭제)
                            //licenseHeaders: {
                            //    "pallycon-customdata" : vodObject.drmHeader,
                            //    "Content-Type": "application/x-www-form-urlencoded"
                            //},

                            certificateUri: fairPlayCertificateUri,
                            getContentId: function (emeOptions, initData) {
                                let contentId = String.fromCharCode.apply(null, new Uint16Array(initData.buffer));
                                let link = document.createElement('a');
                                link.href = contentId.substring(contentId.indexOf('skd://'));
                                let host = link.hostname;
                                return host;
                            }
                        }
                    };
                    break;
            }
        } */

        return source
    }

    addAttribute (element, value) {
        let prop = 'class'
        if (isNull(element)) {
            console.log('InstantPlayer-addAttribute : Invalid parameter. (element= ' + element + ', value= ' + value + ', prop= ' + prop + ')')
            return
        }

        let getProp = []
        try {
            let att = element.getAttribute(prop)

            if (!isNull(att)) {
                if (!isNull(att) && att.indexOf(' ') !== -1) {
                    getProp = att.split(' ')
                } else {
                    getProp.push(att)
                }
            }
        } catch (e) {
            console.error('InstantPlayer-addAttribute: e=' + e)
        }

        /* if (this.mobile === true) {
            let valueA;
            if (value.indexOf(" ") !== -1) {
                valueA = value.split(' ');
            }
            else {
                valueA = [];
                valueA.push(value);
            }
            let v;
            let idx;
            let newValue="";
            for(let i = 0; i < valueA.length; i++) {
                v = valueA[i];
                idx = this.mobilQurryClassA.indexOf(v);
                if (idx !== -1) {
                    v = this.mobilClassA[idx];
                }
                if (i === 0) {
                    newValue = v;
                }
                else {
                    newValue = newValue + " " + v;
                }
            }
            value = newValue;
        }

        if (prop === "style") {
            try {
                let ap=value.split(':')[0];
                let av=value.split(':')[1];
                let p;
                for(let i = 0; i < getProp.length; i++) {
                    p = getProp[i].split(':')[0];
                    if (ap === p){
                        getProp[i]=value;
                        break;
                    }
                }
            }
            catch(e) {
                console.error("InstantPlayer-addAttribute: prop=" + prop + ", e=" + e);
            }
        } */

        let setProp = ''
        for (let i = 0; i < getProp.length; i++) {
            setProp += getProp[i] + ' '
        }
        setProp = setProp + value

        try {
            // jarvis.debuger.log("lib.addAttribute setAttribute prop: "+element+" value : "+value+" prop : "+prop,"e");
            element.setAttribute(prop, setProp)
        } catch (e) {
            console.error('InstantPlayer-addAttribute: setAttribute err (element=' + element + ', value=' + value + ', prop=' + prop + ')')
        }
    }

    removeAttribute (element, value) {
        let prop = 'class'
        if (isNull(element)) {
            console.log('InstantPlayer-removeAttribute: Invalid parameter. (element=' + element + ', value=' + value + ', prop=' + prop + ')')
            return
        }

        let getProp = []
        try {
            let att = element.getAttribute(prop)
            if (!isNull(att)) {
                if (att.indexOf(' ') !== -1) {
                    getProp = att.split(' ')
                } else {
                    getProp.push(att)
                }
            }
        } catch (e) {
            console.error('InstantPlayer-removeAttribute: e=' + e)
        }

        /* if (prop === this.className && this.mobile==true) {
            let v;
            let idx;
            for(let i = 0; i < getProp.length; i++) {
                v = getProp[i];
                idx = this.mobilClassA.indexOf(v);
                if (idx !== -1) {
                    getProp[i]=this.mobilQurryClassA[idx];
                }
            }
        } */
        let values = (value.indexOf(' ') !== -1) ? value.split(' ') : [value]
        let setProp = ''
        for (let i = 0; i < getProp.length; i++) {
            if (values.indexOf(getProp[i]) === -1) {
              if (setProp === ' ') {
                  setProp = getProp[i]
              } else {
                  setProp = setProp + ' ' + getProp[i]
              }
            }
        }
        // jarvis.debuger.log("lib.addAttribute removeAttribute prop: "+element+" value : "+value+" prop : "+prop,"e");
        element.setAttribute(prop, setProp)
    }
}
